document.addEventListener("DOMContentLoaded", () => {
  const initCareCleaning = () => {
    const section = document.querySelector('.product-care-cleaning');
    if (!section) return;

    const tabs = section.querySelectorAll('.product-care-cleaning-tab-button');
    const panels = section.querySelectorAll('.product-care-cleaning-panel');

    if (!tabs.length || !panels.length) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        
        const targetIndex = tab.getAttribute('data-tab-index');

        // Update tab active state
        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        // Update panel active state with smooth fade-in
        panels.forEach((panel, index) => {
          const panelIndex = panel.getAttribute('data-panel-index');
          if (panelIndex === targetIndex || index.toString() === targetIndex) {
            panel.style.display = 'block';
            panel.hidden = false;
            // Force a reflow
            panel.offsetHeight;
            panel.classList.add('is-active');
          } else {
            panel.classList.remove('is-active');
            panel.style.display = 'none';
            panel.hidden = true;
          }
        });
      });

      // Keyboard navigation for accessibility
      tab.addEventListener('keydown', (e) => {
        const index = parseInt(tab.getAttribute('data-tab-index'), 10);
        let nextTab;

        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          nextTab = tabs[(index + 1) % tabs.length];
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          nextTab = tabs[(index - 1 + tabs.length) % tabs.length];
        } else if (e.key === 'Home') {
          nextTab = tabs[0];
        } else if (e.key === 'End') {
          nextTab = tabs[tabs.length - 1];
        }

        if (nextTab) {
          e.preventDefault();
          nextTab.focus();
          nextTab.click();
        }
      });
    });
  };

  initCareCleaning();

  // If using Shopify design mode, re-init on section load
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('section-product-care-cleaning') || e.target.querySelector('.product-care-cleaning')) {
      initCareCleaning();
    }
  });
});
